import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  Inject,
  NgZone
} from '@angular/core';

import { LMCodeBlockComponent } from '@list/code-block/lm-code-block.component';
import { LMCompoundFieldService } from '@services/lm-compound-field.service';

@Component({
  template: `
    <div lm-code-block>
      <ng-template ngFor let-element [ngForOf]="codeBlockFields" let-last="last">
        <div class="field"
             [ngStyle]="{'display': 'inline-flex', 'flex-wrap': 'nowrap'}"
        >
          <label *ngIf="element.displayValue.length > 0; then displayValue else displayLabel"
             soho-label
             lm-label
             [attr.for]="element.id"
             [ngStyle]="{'display': 'inline-flex'}"
          ></label>
          <ng-template #displayLabel>{{element.label}}</ng-template>
          <ng-template #displayValue>{{element.displayValue}}</ng-template>
        </div>
      </ng-template>
      <input type="text"/>
    </div>`,
})

// Template must contain an input elment for an editor
export class LMCodeBlockEditorComponent implements SohoDataGridCellEditor, OnInit {
  @ViewChild(LMCodeBlockComponent, { static: true }) codeblock: LMCodeBlockComponent;

  className = '.code-block';
  name = 'codeblock';

  row: number;
  cell: number;
  value: string;
  columnDef: ListGridColumn;
  dataGrid: SohoDataGridStatic;
  listGridComponent: any;
  dataView: LMListDataView;
  flatLayout: LMFormLayoutElements;
  codeBlockFields: Array<LMListCodeBlockField> = [];

  constructor(
    private lmCompoundFieldService: LMCompoundFieldService,
    private changeDetectorRef: ChangeDetectorRef,
    private ngZone: NgZone,
    @Inject('args') private args: SohoDataGridPostRenderCellArgs) {
    this.value = args.value;
    this.columnDef = args.col as ListGridColumn;
    this.row = args.row;
    this.cell = args.cell;
    this.dataGrid = args.api;
  }

  ngOnInit() {
    this.listGridComponent = this.dataGrid.settings.userObject();
    this.dataView = this.listGridComponent.dataViewSet.data[ this.row ];
    this.flatLayout = this.columnDef.flatLayout;
  }

  val(value?: any) {
    if (value) {
      this.value = value;
    } else if (value === undefined) {
      this.value = this.lmCompoundFieldService.computeCompactFieldValue(this.dataView, this.columnDef.fieldId);
    }
    return this.value;
  }

  focus() {
    const listOpenCompactFormEvent: LMListOpenCompactFormEvent = {
      fieldId: this.columnDef.fieldId,
      title: this.columnDef.displayField.label,
      layout: this.columnDef.displayField.layout,
      dataView: this.dataView,
      row: this.row,
      cell: this.cell,
      datagrid: this.dataGrid,
      columnDef: this.columnDef
    };

    this.listGridComponent.listOpenCompactForm.emit(listOpenCompactFormEvent);
  }
}
